import { SET_CURRENT_USER, LOGOUT_USER } from '../actions/UserActionTypes';

const initialState = {
  currentUser: JSON.parse(localStorage.getItem('userDetails'))?.data || null,
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
        isAuthenticated: true,
      };
    case LOGOUT_USER:
      return {
        ...state,
        currentUser: null,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default UserReducer;
